export default __webpack_public_path__ + "static/media/logo-3.7ad9b6b6.png";